export const highlight = {
  highlight: {
    background: '{primary.100}',
    focusBackground: '{primary.100}',
    color: '{text.color}',
    focusColor: '{text.color}',
  },
};
